<template>
  <ui-overlay-loader :loading="documentUpdating">
    <ui-field
      label-position="inline"
      :label="$t('document_additional_data.document_age')"
      bottom-margin="small"
    >
      {{ calculatedAge }}
    </ui-field>
    <ui-field
      label-position="inline"
      :label="$t('document_additional_data.face_match_score')"
      bottom-margin="small"
    >
      <span
        :class="{
          'text-error': personToDocument.score < personToDocument.threshold,
          'text-success': personToDocument.score >= personToDocument.threshold
        }"
      >
        {{
          typeof personToDocument.score === "number"
            ? personToDocument.score
            : "-"
        }}
      </span>
    </ui-field>
    <ui-field
      v-if="isNfcScanned"
      label-position="inline"
      :label="$t('document_additional_data.nfc_match_score')"
      bottom-margin="small"
    >
      <span
        :class="{
          'text-error': selfieToNfc.score < selfieToNfc.threshold,
          'text-success': selfieToNfc.score >= selfieToNfc.threshold
        }"
      >
        {{ typeof selfieToNfc.score === "number" ? selfieToNfc.score : "-" }}
      </span>
    </ui-field>
  </ui-overlay-loader>
</template>

<script>
import { mapGetters } from "vuex";
import { getters } from "@/store";
import { IDENTIFICATION_SCORES } from "@/constants";
import { calculateAgeFromDateOfBirth } from "@/utils/date";
import { isNFCScanned } from "../utils/documentPhoto";

export default {
  computed: {
    ...mapGetters([
      getters.currentIdentification,
      getters.currentDocumentData,
      getters.documentUpdating
    ]),

    isNfcScanned() {
      return isNFCScanned(this.currentIdentification?.data?.media);
    },

    personToDocument() {
      const personToDocumentData = this.currentIdentification?.data?.scores?.find(
        ({ name }) => name === IDENTIFICATION_SCORES.PERSON_TO_DOCUMENT
      );

      return {
        score: personToDocumentData?.value ?? null,
        threshold: personToDocumentData?.threshold ?? null
      };
    },

    selfieToNfc() {
      const selfieToNfcData = this.currentIdentification?.data?.scores?.find(
        ({ name }) => name === IDENTIFICATION_SCORES.SELFIE_TO_NFC
      );

      return {
        score: selfieToNfcData?.value ?? null,
        threshold: selfieToNfcData?.threshold ?? null
      };
    },

    calculatedAge() {
      return calculateAgeFromDateOfBirth(this.currentDocumentData.dateOfBirth);
    }
  }
};
</script>

<style scoped lang="scss">
.text-success {
  color: var(--text-success);
}

.text-error {
  font-weight: bold;
  color: var(--text-danger);
}
</style>
